<div class="invitacion-wrapper">

  <!-- ── Cargando ── -->
  <div *ngIf="cargando" class="estado-card">
    <div class="estado-icon"><span class="spinner-border"></span></div>
    <h2 class="estado-titulo">Cargando invitación...</h2>
  </div>

  <!-- ── Error de carga / enlace inválido ── -->
  <div *ngIf="!cargando && errorCarga" class="estado-card estado-despues">
    <div class="estado-icon"><i class="fa fa-exclamation-triangle"></i></div>
    <h2 class="estado-titulo">No se pudo cargar la invitación</h2>
    <p class="estado-descripcion">{{ errorCarga }}</p>
  </div>

  <ng-container *ngIf="!cargando && !errorCarga">

    <!-- ── Sin temas/actividades registradas ── -->
    <div *ngIf="sinTemas" class="estado-card estado-antes">
      <div class="estado-icon"><i class="fa fa-info-circle"></i></div>
      <h2 class="estado-titulo">Aún no hay actividades programadas</h2>
      <p class="estado-descripcion">
        Esta programación todavía no tiene temas con horario asignado.
      </p>
      <div class="capacitacion-info" *ngIf="capacitacionNombre">
        <i class="fa fa-graduation-cap me-2"></i>
        {{ capacitacionNombre }}
      </div>
    </div>

    <!-- ── No hay ningún tema activo ahora mismo, pero hay uno próximo ── -->
    <div *ngIf="!sinTemas && temasActivos.length === 0 && proximoTema" class="estado-card estado-antes">
      <div class="estado-icon"><i class="fa fa-clock-o"></i></div>
      <h2 class="estado-titulo">La próxima actividad aún no ha comenzado</h2>

      <p class="estado-descripcion">
        Podrás confirmar tu asistencia a
        <strong>{{ proximoTema.nombre_tema }}</strong>
        a partir de las <strong>{{ proximoTema.horaInicioFormateada }}</strong>
        del <strong>{{ proximoTema.fechaFormateada }}</strong>.
      </p>

      <div class="capacitacion-info" *ngIf="capacitacionNombre">
        <i class="fa fa-graduation-cap me-2"></i>
        {{ capacitacionNombre }}
      </div>

      <p class="estado-nota">
        <i class="fa fa-info-circle me-1"></i>
        Por favor regresa a este mismo enlace en el horario indicado.
      </p>
    </div>

    <!-- ── Ningún tema activo y no hay ninguno próximo: todo finalizó ── -->
    <div *ngIf="!sinTemas && temasActivos.length === 0 && !proximoTema && todosFinalizados"
      class="estado-card estado-despues">
      <div class="estado-icon"><i class="fa fa-times-circle"></i></div>
      <h2 class="estado-titulo">El tiempo para confirmar ha finalizado</h2>

      <p class="estado-descripcion">
        Ya no hay temas activos para confirmar asistencia en esta programación.
      </p>

      <div class="capacitacion-info" *ngIf="capacitacionNombre">
        <i class="fa fa-graduation-cap me-2"></i>
        {{ capacitacionNombre }}
      </div>

      <p class="estado-nota">
        <i class="fa fa-info-circle me-1"></i>
        Si crees que es un error, contacta al organizador de la capacitación.
      </p>
    </div>

    <!-- ── Hay tema(s) vigente(s): checklist + formulario ── -->
    <div *ngIf="!sinTemas && temasActivos.length > 0">

      <!-- ── Banner ── -->
      <div class="capacitacion-banner bg-primary">
        <div class="banner-icon"><i class="fa fa-graduation-cap"></i></div>
        <div class="banner-texto">
          <h1 class="banner-titulo">Confirmación de Asistencia</h1>
          <p class="banner-subtitulo" *ngIf="capacitacionNombre">{{ capacitacionNombre }}</p>
        </div>
      </div>

      <!-- ── Checklist de temas activos ── -->
      <div class="formulario-card" *ngIf="!confirmado">
        <h3 class="formulario-titulo">
          <i class="fa fa-list-check me-2"></i>
          Selecciona los temas a los que estás asistiendo
        </h3>

        <div class="actividad-item" *ngFor="let tema of temasActivos" (click)="toggleTema(tema)"
          [class.actividad-item-seleccionada]="estaSeleccionado(tema)">
          <input type="checkbox" class="actividad-checkbox" [checked]="estaSeleccionado(tema)"
            (click)="$event.stopPropagation(); toggleTema(tema)" />
          <div class="actividad-info">
            <strong>{{ tema.nombre_tema }}</strong>
            <span>{{ tema.fechaFormateada }} · {{ tema.horaInicioFormateada }} – {{ tema.horaFinFormateada }}</span>
          </div>
        </div>

        <hr>

        <div class="campo-grupo">
          <label class="campo-label">
            N° de Documento
            <span class="campo-requerido">*</span>
          </label>
          <input type="number" class="campo-input" placeholder="Ej. 1098765432" [(ngModel)]="cedula"
            [disabled]="isEnviando" />
        </div>

        <div class="campo-grupo">
          <label class="campo-label">
            Nombre Completo
            <span class="campo-requerido">*</span>
          </label>
          <input type="text" class="campo-input text-uppercase" placeholder="Ej. JUAN PÉREZ" [(ngModel)]="nombre"
            [disabled]="isEnviando" (keyup.enter)="confirmarAsistencia()" />
        </div>

        <button class="btn-confirmar bg-primary" [class.btn-loading]="isEnviando"
          [disabled]="isEnviando || !formularioValido" (click)="confirmarAsistencia()">

          <span *ngIf="!isEnviando">
            <i class="fa fa-check-circle me-2"></i>
            Confirmar asistencia ({{ temasSeleccionados.length }})
          </span>

          <span *ngIf="isEnviando">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Registrando...
          </span>
        </button>

        <p class="campo-nota">
          <i class="fa fa-lock me-1"></i>
          Tus datos se usarán únicamente para el registro de asistencia.
        </p>
      </div>

      <!-- ── Confirmación exitosa ── -->
      <div class="exito-card" *ngIf="confirmado">
        <div class="exito-icon">
          <i class="fa fa-check-circle"></i>
        </div>
        <h2 class="exito-titulo">¡Asistencia confirmada!</h2>
        <p class="exito-descripcion">
          Tu asistencia a <strong>{{ capacitacionNombre }}</strong> fue registrada correctamente
          para {{ temasSeleccionados.length }} {{ temasSeleccionados.length === 1 ? 'tema' : 'temas' }}.
        </p>
        <p class="exito-nota">¡Gracias por confirmar!</p>
      </div>

    </div>

  </ng-container>

</div>